













import { Component, Vue, Prop } from "vue-property-decorator";

@Component
export default class Card extends Vue {
  @Prop({ default: "" })
  title!: string;

  get actionsFilled() {
    return this.$slots.actions !== undefined && this.$slots.actions.length > 0;
  }
}
